var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_1dbb07e4"]},_vm.$listeners),[_c('cube-button',{attrs:{"outline":"","scope":"userInfo","tip":"需在小程序环境下预览"},on:{"getUserInfo":(e)=>_vm.__invoke(e, [["onGetUserInfo"]])}},[_vm._v("获取用户信息")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }